import { APIOps } from "@/apis/api-config";
import ApiPaths from "@/apis/base-api-paths";

export default class AppAuthApi extends ApiPaths {
  async memberMe(): Promise<
    APIOps["member_info_api_app_auth_member_me_get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get(this.toAuthURL("member-me"))).data;
  }
  async withdrawPreCheck(): Promise<
    APIOps["member_withdraw_pre_check_api_app_auth_withdraw_pre_check_get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get(this.toAuthURL("withdraw/pre-check"))).data;
  }
  async withdraw(
    props: APIOps["member_withdraw_api_app_auth_withdraw_post"]["requestBody"]["content"]["application/json"],
  ): Promise<APIOps["member_withdraw_api_app_auth_withdraw_post"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.post(this.toAuthURL("withdraw"), props)).data;
  }
  async upDateMember(
    props: APIOps["update_member_info_api_app_auth_member_me_put"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIOps["update_member_info_api_app_auth_member_me_put"]["responses"]["201"]["content"]["application/json"]
  > {
    return (await this.put(this.toAuthURL("member-me"), props)).data;
  }
  async signup(
    props: APIOps["signup_api_app_auth_signup_post"]["requestBody"]["content"]["application/json"],
  ): Promise<APIOps["signup_api_app_auth_signup_post"]["responses"]["201"]["content"]["application/json"]> {
    return (await this.post(this.toAuthURL("signup"), props)).data;
  }
  async checkFirebaseUser(): Promise<
    APIOps["check_firebase_user_api_app_auth_check_firebase_user_get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get(this.toAuthURL("check-firebase-user"))).data;
  }
  async upDateInstagramAccounts(
    facebook_first_token: APIOps["update_instagram_info_api_app_auth_instagram_me_get"]["parameters"]["query"]["facebook_first_token"],
  ): Promise<
    APIOps["update_instagram_info_api_app_auth_instagram_me_get"]["responses"]["201"]["content"]["application/json"]
  > {
    return (await this.get(this.toAuthURL(`instagram-me?facebook_first_token=${facebook_first_token}`))).data;
  }
  async deleteInstagramAccount(
    instagram_account_id: APIOps["delete_my_instagram_tunnel_api_app_auth_instagram_me_delete"]["parameters"]["query"]["instagram_account_id"],
  ): Promise<
    APIOps["delete_my_instagram_tunnel_api_app_auth_instagram_me_delete"]["responses"]["204"]["content"]["application/json"]
  > {
    return await this.delete(this.toAuthURL(`instagram-me?instagram_account_id=${instagram_account_id}`));
  }
  async upDateFavoriteInstagram(
    instagram_account_id: APIOps["update_favorite_instagram_account_api_app_auth_member_favorite_instagram_put"]["parameters"]["query"]["instagram_account_id"],
  ): Promise<
    APIOps["update_favorite_instagram_account_api_app_auth_member_favorite_instagram_put"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.put(this.toAuthURL(`member-favorite-instagram?instagram_account_id=${instagram_account_id}`)))
      .data;
  }
  async updateFacebookInfo(
    props: APIOps["update_facebook_info_api_app_auth_update_facebook_info_put"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIOps["update_facebook_info_api_app_auth_update_facebook_info_put"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.put(this.toAuthURL("update-facebook-info"), props)).data;
  }
  async resolveFacebookConflict(
    props: APIOps["resolve_facebook_conflict_api_app_auth_resolve_facebook_conflict_post"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIOps["resolve_facebook_conflict_api_app_auth_resolve_facebook_conflict_post"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.post(this.toAuthURL("resolve-facebook-conflict"), props)).data;
  }
  async sendPasswordResetEmail(
    props: APIOps["send_password_reset_api_public_auth_send_password_reset_email_post"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIOps["send_password_reset_api_public_auth_send_password_reset_email_post"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.post(this.toPublicAuthURL("send-password-reset-email"), props)).data;
  }
  async colormeAuthorizeUrl(): Promise<
    APIOps["colorme_authorize_url_api_public_auth_colorme_authorize_url_get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get(this.toPublicAuthURL("colorme/authorize-url"))).data;
  }
  async colormeLogin(
    props: APIOps["colorme_login_api_public_auth_colorme_login_post"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIOps["colorme_login_api_public_auth_colorme_login_post"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.post(this.toPublicAuthURL("colorme/login"), props)).data;
  }
}
